import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { stringStep } from '../../../concepts/commands/CommandWizard';
import { resolveSubjects } from '../../canvas/commands/CommandUtil';
import { Physicals } from '../../canvas/entities/Physicals';
import { NativeVideo } from './NativeVideo';
import { Playable } from './Playable';
import { VideoStateAttr } from './VideoAttributes';
import { VideoController } from './VideoController';
import { YouTubeVideo } from './YouTubeVideo';

export const parseYouTubeVideoId = (url: string) => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url.match(regExp);
    return (match && match[7].length === 11) ? match[7] : false;
};

export const createYouTubeVideo = defineCommand(
    'createYouTubeVideo',
    'Create: YouTube Video',
    (r, [url]: [string?]) => {
        Physicals.createAtCameraPosition(r, YouTubeVideo, nc => {
            nc.width = 1024;
            nc.height = 576;
            nc.videoId = parseYouTubeVideoId(url) || 'gnnIrTLlLyA';
        });
    },
    [
        stringStep('url', 'Enter the URL of the video:')
    ]
);

export const createNativeVideo = defineCommand(
    'createNativeVideo',
    'Create: Native Video',
    (r, [url]: [string?]) => {
        Physicals.createAtCameraPosition(r, NativeVideo, nc => {
            nc.width = 1024;
            nc.height = 576;
            nc.url = url;
        });
    },
    [
        stringStep('url', 'Enter the URL of the video:')
    ]
);

export const videoPlay = defineCommand(
    'videoPlay',
    'Video: Play',
    (r, [targetIds]: [string[]?]) => {

        const ctrl = r.call(VideoController);
        const subjects = resolveSubjects(r, targetIds, Playable);
        if (!subjects.length) return;

        for (const s of subjects) {
            const state = VideoStateAttr.get(s);
            if (state === 'stopped') {
                ctrl.playOrStop(s.id);
            }
        }

    }
);

export const videoStop = defineCommand(
    'videoStop',
    'Video: Stop',
    (r, [targetIds]: [string[]?]) => {

        const ctrl = r.call(VideoController);
        const subjects = resolveSubjects(r, targetIds, Playable);
        if (!subjects.length) return;

        for (const s of subjects) {
            const state = VideoStateAttr.get(s);
            if (state === 'playing') {
                ctrl.playOrStop(s.id);
            }
        }
    }
);

export const inVideoCommands = () => inCommands(createYouTubeVideo, createNativeVideo, videoPlay, videoStop);
